export function generateFilterSummary( filters ) {
    const parts = [];
  
    if (filters.dateRange) parts.push(prettyDateRange(filters.dateRange, filters.startDate, filters.endDate));
    if (filters.loanPurpose.length) parts.push(`Purpose: ${filters.loanPurpose.join(', ')}`);
    if (filters.loanType.length) parts.push(`Type: ${filters.loanType.join(', ')}`);
    if (filters.state.length) parts.push(`State: ${filters.state.join(', ')}`);
    if (filters.minLoanAmount || filters.maxLoanAmount) {
      const min = filters.minLoanAmount ? `$${Number(filters.minLoanAmount).toLocaleString()}` : '';
      const max = filters.maxLoanAmount ? `$${Number(filters.maxLoanAmount).toLocaleString()}` : '';
      parts.push(`Loan Amount: ${min}–${max}`);
    }
  
    return parts.join(' | ');
}
  
function prettyDateRange( range, start, end ) {
    if ( range === 'custom' && start && end ) {
      return `${new Date(start).toLocaleDateString()} - ${new Date(end).toLocaleDateString()}`;
    }
    return {
        last30days: 'Last 30 Days',
        last90days: 'Last 90 Days',
        last180days: 'Last 180 Days',
        ytd: 'Year to Date',
    }[range] || 'All Time';
}  